/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { DatePicker, Radio, Select, Button, Input, Spin, message, Tabs } from 'antd'
import moment from 'moment'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'
import Report from './report'
import ModalSn from './modalSn'
import ModalMeal from './modalMeal'
import './style.css'
import {
  LAST_MONTH,
  LAST_YEAR,
  THIS_MONTH,
  THIS_YEAR,
  TODAY,
  YESTERDAY,
} from '../../../util/const'
import { fetchMealRecordDetails } from '../action'
const { RangePicker } = DatePicker
const Option = Select.Option
const Search = Input.Search
const { TabPane } = Tabs

export default class extends React.Component {
  state = {
    activeTab: 'income',
    dateSize: '0',
    radioValue: 2,
    visible: false,
    record_type: '', //当前选择的记录类型
    table_record_type: '', //表格的记录类型
    recordObj: [
      { id: 1, value: '消费记录' },
      { id: 2, value: '充值记录' },
      { id: 3, value: '卡券记录' },
      { id: 4, value: '套餐收入记录' },
      { id: 5, value: '预订记录' },
      { id: 6, value: '定时记录' },
      { id: 7, value: '团购记录' },
    ],
    record_type_name: '',
    payment_id: [],
    remark_payment_id: '',
    loading: false,
    mealList: [],
    mealVisible: false,
    firstSelectedTime: '',
  }

  componentDidMount() {
    const clubId = sessionStorage.getItem('club_id')


  }

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.props.getPeriod({
        start_time: dateString[0],
        end_time: dateString[1],
      })
    } else {
      this.props.getPeriod({ start_time: null, end_time: null }) //清除
    }
  }

  handleSizeChange = (e) => {
    this.setState({ dateSize: e.target.value })
    this.props.fetchTimePeriod(e.target.value) //时间范围
  }

  handleChange = (value) => {
    this.setState({
      record_type: value + '',
      record_type_name: this.state.recordObj[value - 1].value,
    })
    this.props.fetchPaymentList(value) //支付方式
  }

  paymentSelect = (value) => {
    this.setState({ payment_id: value })
  }

  remarkPaymentSelect = (value) => {
    this.setState({ remark_payment_id: value })
  }

  handleTabChange = (key) => {
    this.setState({ activeTab: key })
    if (key === 'remark' && (!this.props.paymentList || this.props.paymentList.length === 0)) {
      this.props.fetchPaymentList(1)
    }
  }

  handleButton = () => {
    const { start_time, end_time } = this.props.period
    const { activeTab, radioValue } = this.state
    if (!start_time || !end_time) {
      message.info('请选择时间')
      return
    }
    const startTime = moment(start_time).format('YYYY-MM-DD HH:mm:ss')
    const endTime = moment(end_time).format('YYYY-MM-DD HH:mm:ss')
    if (activeTab === 'remark') {
      this.setState({ loading: true })
      this.props.fetchBillRemarks({
        club_id: +sessionStorage.getItem('club_id'),
        start_time: startTime,
        end_time: endTime,
        payment_type: this.state.remark_payment_id,
        statisticType: radioValue,
      }).then(() => {
        this.setState({ loading: false })
      })
      return
    }
    if (this.state.record_type.length > 0) {
      let data = {
        recharge: +this.state.record_type,
        type: this.state.payment_id,
        start_time: startTime,
        end_time: endTime,
        statisticType: radioValue,
      }
      this.setState({
        loading: true,
        table_record_type: this.state.record_type,
      })
      this.props.fetchIncomeBusiness(data).then((res) => {
        this.setState({
          loading: false,
        })
      })
    } else {
      message.info('请选择记录')
    }
  }

  onChangeNumber = (e) => {
    this.setState({ number: e.target.value })
  }

  handleOk = () => {
    this.setState({ visible: false })
  }
  handleCancel = () => {
    this.setState({ visible: false })
  }

  snSelect = async (value) => {
    if (value.length == 0 || value == '') {
      message.error('请输入订单号查询')
      return
    }
    if (this.state.record_type === '4') {
      const list = await fetchMealRecordDetails(value)
      if (list) {
        this.setState({
          mealVisible: true,
          mealList: list[0] ? list[0].bills : [],
        })
      }
      return
    }
    this.props.fetchSnDetails(value)
    const tArray = await this.props.getPurchaseServices({
      temporaryNumbers: value,
    })
    const sArray = await this.props.getPurchaseServices({
      serialNumbers: value,
    })
    this.props.settingsPurchases([].concat(tArray).concat(sArray))
    this.setState({ visible: true })
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  render() {
    const {
      activeTab,
      dateSize,
      radioValue,
      record_type,
      recordObj,
      record_type_name,
      table_record_type,
    } = this.state
    const {
      paymentList,
      period,
      business,
      recordDetail,
      incomeSumList,
      serviceList,
      billRemarkList,
      billRemarkSumList,
    } = this.props

    const disabledDate = (current) => {
      if (current && this.state.firstSelectedTime) {
        if (
          current.isAfter(
            moment(this.state.firstSelectedTime)
              .add(3, 'months')
              .subtract(1, 'days')
          )
        ) {
          return true
        }
      }
    }

    const onCalendarChange = (dates, dateStrings, info) => {
      if (dateStrings) {
        this.setState({ firstSelectedTime: dateStrings[0] })
      }
    }

    const onOpenChange = (open) => {
      if (!open) {
        // this.setState({ firstSelectedTime: '' })
      }
    }

    const isIncomeTab = activeTab === 'income'
    const currentList = isIncomeTab ? business : billRemarkList
    const currentSumList = isIncomeTab ? incomeSumList : billRemarkSumList
    const effectiveTableRecordType = activeTab === 'remark' ? 'remark' : table_record_type

    return (
      <div>
        <Tabs activeKey={activeTab} onChange={this.handleTabChange}>
          <TabPane tab="收入明细" key="income">
            <div className="business">
              <div className="business-left">
                <Radio.Group
                  value={dateSize}
                  onChange={this.handleSizeChange}
                  style={{ display: 'block', marginBottom: '1rem' }}
                >
                  <Radio.Button value={YESTERDAY}>昨日</Radio.Button>
                  <Radio.Button value={TODAY}>今日</Radio.Button>
                  <Radio.Button value={LAST_MONTH}>上月</Radio.Button>
                  <Radio.Button value={THIS_MONTH}>本月</Radio.Button>
                  {/* <Radio.Button value={LAST_YEAR}>去年</Radio.Button>
                  <Radio.Button value={THIS_YEAR}>今年</Radio.Button> */}
                </Radio.Group>
                <div>
                  <RangePicker
                    format="YYYY-MM-DD"
                    placeholder={['开始时间', '结束时间']}
                    value={
                      period.start_time
                        ? [
                            moment(period.start_time, 'YYYY-MM-DD'),
                            moment(period.end_time, 'YYYY-MM-DD'),
                          ]
                        : ''
                    }
                    onChange={this.onChange}
                    disabledDate={disabledDate}
                    onCalendarChange={onCalendarChange}
                    onOpenChange={onOpenChange}
                  />
                  <NineAndZeroRadio typeEvent={this.onTypeEvent} />
                </div>
                <Select
                  style={{ width: 200, marginTop: '1rem', display: 'block' }}
                  placeholder="选择记录"
                  onChange={this.handleChange}
                >
                  {recordObj.map((item) => {
                    return (
                      <Option value={item.id} key={item.id}>
                        {item.value}
                      </Option>
                    )
                  })}
                </Select>
                <Select
                  mode="multiple"
                  style={{ width: 200, marginTop: '1rem', display: 'block' }}
                  placeholder="选择支付方式,可不选择"
                  onChange={(value) => this.paymentSelect(value)}
                >
                  {/*<Option value="">全部</Option>*/}
                  {paymentList.map((item) => {
                    return (
                      <Option value={item.id} key={item.id}>
                        {item.name}
                      </Option>
                    )
                  })}
                </Select>
                <div style={{ marginTop: '1rem' }}>
                  <Button type="primary" onClick={() => this.handleButton()}>
                    {/*<Link to={'/home/ClubBusiness/Report/'+ record_type}>显示</Link>*/}
                    显示
                  </Button>
                </div>
              </div>

              <div className="business-right">
                <p style={{ lineHeight: '2rem' }}>订单号查记录:</p>
                <Search
                  placeholder="请输入订单号查询"
                  style={{ width: 200 }}
                  onSearch={this.snSelect}
                />
              </div>
            </div>
          </TabPane>

          <TabPane tab="备注记录" key="remark">
            <div className="business">
              <div className="business-left">
                <Radio.Group
                  value={dateSize}
                  onChange={this.handleSizeChange}
                  style={{ display: 'block', marginBottom: '1rem' }}
                >
                  <Radio.Button value={YESTERDAY}>昨日</Radio.Button>
                  <Radio.Button value={TODAY}>今日</Radio.Button>
                  <Radio.Button value={LAST_MONTH}>上月</Radio.Button>
                  <Radio.Button value={THIS_MONTH}>本月</Radio.Button>
                </Radio.Group>
                <div>
                  <RangePicker
                    format="YYYY-MM-DD"
                    placeholder={['开始时间', '结束时间']}
                    value={
                      period.start_time
                        ? [
                            moment(period.start_time, 'YYYY-MM-DD'),
                            moment(period.end_time, 'YYYY-MM-DD'),
                          ]
                        : ''
                    }
                    onChange={this.onChange}
                    disabledDate={disabledDate}
                    onCalendarChange={onCalendarChange}
                    onOpenChange={onOpenChange}
                  />
                  <NineAndZeroRadio typeEvent={this.onTypeEvent} />
                </div>
                <Select
                  style={{ width: 200, marginTop: '1rem', display: 'block' }}
                  placeholder="选择支付方式,可以不选择"
                  onChange={(value) => this.remarkPaymentSelect(value)}
                  allowClear
                >
                  {paymentList.map((item) => {
                    return (
                      <Option value={item.id} key={item.id}>
                        {item.name}
                      </Option>
                    )
                  })}
                </Select>
                <div style={{ marginTop: '1rem' }}>
                  <Button type="primary" onClick={() => this.handleButton()}>
                    显示
                  </Button>
                </div>
              </div>
            </div>
          </TabPane>
        </Tabs>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Report
            activeTab={activeTab}
            statisticType={radioValue}
            incomeSumList={currentSumList}
            list={currentList}
            period={period}
            table_record_type={effectiveTableRecordType}
            record_type_name={record_type_name}
            recordDetail={recordDetail}
            serviceList={serviceList}
            fetchRecordDetails={this.props.fetchRecordDetails}
            settingsPurchases={this.props.settingsPurchases}
            getPurchaseServices={this.props.getPurchaseServices}
            exportBillRemarks={this.props.exportBillRemarks}
          />
        )}

        <ModalSn
          {...this.state}
          list={recordDetail}
          serviceList={serviceList}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
        />

        <ModalMeal
          visible={this.state.mealVisible}
          list={this.state.mealList}
          handleOk={() => this.setState({ mealVisible: false })}
          handleCancel={() => this.setState({ mealVisible: false })}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/component/business.js